import devtools from 'devtools-detect';

let devToolsOpened = false;

// Function to check for DevTools opening
const checkDevTools = () => {
    // Detect using window size
    if (window.outerWidth - window.innerWidth > 100 || window.outerHeight - window.innerHeight > 160) {
        if (!devToolsOpened) {
            devToolsOpened = true;
            console.log("Developer Tools Opened");
            logoutUser(); // Log out user or take other actions
        }
    }

    // Detect using devtools-detect library
    if (devtools.isOpen) {
        if (!devToolsOpened) {
            devToolsOpened = true;
            console.log("Developer Tools Opened via devtools-detect");
            logoutUser(); // Log out user or take other actions
        }
    }
};

const logoutUser = () => {
    console.log("Logging out user for security reasons");
    // Clear sessionStorage
    sessionStorage.clear();

    // Clear localStorage
    localStorage.clear();

    // Clear cookies
    document.cookie.split(';').forEach(function (cookie) {
        const cookieName = cookie.split('=')[0].trim();
        document.cookie = cookieName + '=; Max-Age=0; path=/'; // Expire the cookie
    });

    // Delete IndexedDB
    const deleteIndexedDB = async () => {
        const dbNames = await indexedDB.databases();
        dbNames.forEach(db => {
            const request = indexedDB.deleteDatabase(db.name);
            request.onsuccess = () => {
                console.log(`IndexedDB "${db.name}" deleted successfully.`);
            };
            request.onerror = () => {
                console.log(`Error deleting IndexedDB "${db.name}".`);
            };
        });
    };

    deleteIndexedDB(); // Call to delete IndexedDB
    //window.location.href = '/login';  // Redirect to login page or take another action
    window.location.reload(); // Refresh the page
};

// Start checking for DevTools every 5 seconds
const startDevToolsDetection = () => {
    setInterval(checkDevTools, 2000);
};

// Export the start function
export default startDevToolsDetection;
